export default {
      id: "pie-chart-usage",
      viewBox: "0 0 40 61",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#pie-chart",
      toString: function () {
        return this.url;
      }
    }